import { AnalyticsActions } from '../analytics-action.enum';
import { AnalyticsCategories } from '../analytics-category.enum';
import { InViewportComponent } from '../in-viewport.component';
import { AnalyticsRule } from './analytics-rule.interface';

export const popupSearchRules: AnalyticsRule[] = [
  {
    url: '/menus/search/popup',
    path: 'popup-search-header scroll-to-content',
    events: 'click',
    definition: {
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.POP_UP_HEADER,
      label: 'Explore options'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'popup-search-header more-info',
    events: 'click',
    definition: {
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.POP_UP_HEADER,
      label: 'Find out more'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'parameters-form postcode',
    events: 'change',
    definition: {
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.SEARCH_POPUP,
      label: 'Postcode set'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'parameters-form date',
    events: 'change',
    definition: {
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.SEARCH_POPUP,
      label: 'Date set'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'parameters-form time',
    events: 'change',
    definition: {
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.SEARCH_POPUP,
      label: 'Time set'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'marketplace-search-popup',
    events: {
      class: 'SearchParametersPopupContentComponent',
      eventName: 'complete',
    },
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_POPUP,
      label: 'Submit search'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'search-query-input',
    events: 'blur',
    definition: {
      action: AnalyticsActions.BLUR,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'Search query entered',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'sort-by-select',
    events: 'change',
    definition: (event) => ({
      action: AnalyticsActions.SELECT,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: `Sort by ${event.data['sort-by-select']}`,
    }),
  },
  {
    url: '/menus/search/popup',
    path: 'headcount-input',
    events: 'blur',
    definition: {
      action: AnalyticsActions.BLUR,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'No of people',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'max-budget-input',
    events: 'blur',
    definition: {
      action: AnalyticsActions.BLUR,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'Budget per person',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'occasions-box',
    events: 'click',
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'Occasion box toggled',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'occasions-checkbox',
    events: 'click',
    definition: (event) => ({
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: `${event.data['occasions-checkbox']} occasion checked/unchecked`,
    }),
  },
  {
    url: '/menus/search/popup',
    path: 'cuisine-types-box',
    events: 'click',
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'Type Of cuisine box toggled',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'cuisine-types-checkbox',
    events: 'click',
    definition: (event) => ({
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: `${event.data['cuisine-types-checkbox']} cuisine type checked/unchecked`,
    }),
  },
  {
    url: '/menus/search/popup',
    path: 'dietary-concerns-box',
    events: 'click',
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'Dietary Concerns box toggled',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'dietary-concerns-checkbox',
    events: 'click',
    definition: (event) => ({
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: `${event.data['dietary-concerns-checkbox']} dietary requirement checked/unchecked`,
    }),
  },
  {
    url: '/menus/search/popup',
    path: 'filters-form',
    events: {
      class: 'SearchFiltersFormComponent',
      eventName: 'changeWeWorkMode',
    },
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_PARAMETERS,
      label: 'WeWork Friendly vendors toggle',
    },
  },
  {
    url: '/menus/search/popup',
    path: 'search-result link',
    events: 'click',
    definition: (event) => {
      if (event.data['search-result']['isTopPick']) {
        return [{
          action: AnalyticsActions.CLICK,
          category: AnalyticsCategories.SEARCH_RESULT,
          label: 'Top Pick Result'
        }, {
          action: AnalyticsActions.CLICK,
          category: AnalyticsCategories.SEARCH_RESULT,
          label: 'Vendor'
        }];
      } else {
        return {
          action: AnalyticsActions.CLICK,
          category: AnalyticsCategories.SEARCH_RESULT,
          label: 'Vendor'
        };
      }
    }
  },
  {
    url: '/menus/search/popup',
    path: 'search-page search-result result-favourite-button',
    events: 'click',
    definition: (event) => ({
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_RESULT,
      label: `vendor ${event.data['result-favourite-button'].isFavourited ? 'added to' : 'removed from'} favourites`,
    }),
  },
  {
    url: '/menus/search/popup',
    path: 'cant-find-what-you-want suggest-a-restaurant',
    events: 'click',
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_RESULT,
      label: 'Can\'t find what you want - Suggest a restaurant'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'cant-find-what-you-want chat-to-us',
    events: 'click',
    definition: {
      action: AnalyticsActions.CLICK,
      category: AnalyticsCategories.SEARCH_RESULT,
      label: 'Can\'t find what you want - Chat to us'
    }
  },
  {
    url: '/menus/search/popup',
    path: 'cant-find-what-you-want top-of-component',
    events: InViewportComponent.events.firstSeen,
    definition: {
      action: AnalyticsActions.VIEW,
      category: AnalyticsCategories.SEARCH_RESULT,
      label: `can't find what your looking for in viewport`
    }
  },
];
